export default function GreenCheckMark({
    style
}) {
    return  <svg style={style} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill="#0E9247"/>
    <path d="M3 5.84615L5.52632 8L9 4" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}